import React, { Component } from 'react';
import SideDrawer from "../Menu/SideDrawer";
import BackDrop from "../Menu/BackDrop";
import Container from "@material-ui/core/Container";
import Toolbar from "../Menu/Toolbar";
import TextTerms from './TextTerms';


export default class Info extends Component {
    constructor() {
      super();
      this.state = { value: '' ,isLoading: true, allData: {}, menuOpen: false};
      this.onChange = this.onChange.bind(this);
      this.add = this.add.bind(this);
  }

  add() {
    this.props.onButtonClick(this.state.value);
    this.setState({ value: '' });
  }

  onChange(e) {
    this.setState({ value: e.target.value });
  }

  menuClickHandler = () => {
    this.setState((prevState) => {
      return { menuOpen: !prevState.menuOpen };
    });
  };

  backDropClickHandler = () => {
    this.setState({ menuOpen: false });
  };

    render() {
      let sideDrawer;
      let backDrop;

    if (this.state.menuOpen) {
      sideDrawer = <SideDrawer closeMenu={this.backDropClickHandler} />;
      backDrop = <BackDrop click={this.backDropClickHandler} />;
    }
      return (
        <Container component="main" maxWidth="xs">
            <Toolbar drawerClickHandler={this.menuClickHandler} textPage="תנאי שימוש"/>
            {sideDrawer}
            {backDrop}
          <TextTerms/>    
     </Container>
  
      )
    }
}